module.exports = __webpack_public_path__ + "img/dash-circle.52a53118.svg";